import React from 'react';
import PropTypes from 'prop-types';
import Grid from '../../../Grid';
import Select from '../../../Select';
import Label from '../../../Label';
import MobileFilters from '../../../MobileFilters';
import Icon from '../../../Icon';
import { ICONS } from '../../../../constants';

const TopBar = ({
  isDesktop,
  className,
  filterProps,
  sortByProps: { sortBy, options, onSortBy, label },
  priceIntervalProps,
  ...rest
}) => (
  <section className={className} {...rest}>
    <div>
      <Grid
        container
        alignItems="center"
        justify="space-between"
        spacing="fluid"
      >
        <Grid item xs={12} sm="auto">
          {!isDesktop && (
            <MobileFilters {...filterProps} {...priceIntervalProps} />
          )}
        </Grid>
        <Grid item xs={12} sm="auto">
          <Select
            value={sortBy}
            options={options}
            onChange={({ target: { value } }) => onSortBy(value)}
            label={<Label bold uppercase label={label} />}
            showLabel={isDesktop ? 'inline' : false}
            basic
            fluid={!isDesktop}
            iconRight={!isDesktop}
            right={props => <Icon name={ICONS.ARROWS} {...props} />}
            mobile={!isDesktop}
            ariaLabel="Sort by"
          />
        </Grid>
      </Grid>
    </div>
  </section>
);

TopBar.propTypes = {
  className: PropTypes.string,
  filterProps: PropTypes.shape({
    onFilterChange: PropTypes.func.isRequired,
    filters: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        type: PropTypes.oneOf(['filter', 'priceInterval']),
        items: PropTypes.shape(), // Not required for type priceInterval
      }).isRequired,
    ).isRequired,
  }).isRequired,
  isDesktop: PropTypes.bool.isRequired,
  sortByProps: PropTypes.shape(),
  priceIntervalProps: PropTypes.shape(),
};

TopBar.defaultProps = {
  className: null,
  sortByProps: { sortBy: '', options: [], onSortBy: {}, label: '' },
  priceIntervalProps: {},
};

export default TopBar;
